$(document).ready(function () {
    $(document).on("click", ".js-cart-item-delete", function () {
        var ItemID = $(this).attr("data-id");
        var LangID = $("#LangID").val();
        var element = $(this);

        GenerateLocalLoading(element.closest(".cart-item"), "show");

        RemoveFromCart(ItemID, LangID, function (status, dt) {
            GenerateLocalLoading(element.closest(".cart-item"), "hide");

            if (status) {
                GetBasketItems();
                //GiftPackageControl();
                RefreshOrderSummary();

                //RefreshRevotasCartData();
            }
            else {
                SwalGenerate("error", dt, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            }
        });
    });

    $(document).on("click", ".js-update-quantity", function () {
        var basketID = $(this).attr("data-id");
        var Amount = $(this).attr("data-qty");
        var LangID = $("#LangID").val();

        GenerateLocalLoading($(".js-cart-items-wrapper"), "show");

        UpdateCartAmount(basketID, Amount, LangID, function (dt, msg) {
            GenerateLocalLoading($(".js-cart-items-wrapper"), "hide");

            if (dt == true) {
                GetBasketItems();
                //GiftPackageControl();
                RefreshOrderSummary();

                //RefreshRevotasCartData();
            }
            else {
                SwalGenerate("error", msg, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            }
        });
    });
});